import axios from 'axios'
import { alert } from "devextreme/ui/dialog"
const baseUri = "WebApi.asmx/api/resourceTypeMediaService";
const store = {};
const mutations = {
    GET_RESOURCETYPEMEDIA_LIST(state, posts) {
        state.resourceTypeMediaList = posts.list;
    }, 
};

const state = { 
    resourceTypeMediaList: [],
};

const getters = {};

const actions = {
    getResourceTypeMediaList({ commit }) { 
        axios
            .get(baseUri + '/GetList')
            .then(res => {
                if (res.data.success == true) {
                    commit('GET_RESOURCETYPEMEDIA_LIST', res.data);
                }
                else {
                    alert(res.data.errorMessage);
                }
            });
    }, 
};


export default {
    state,
    store,
    mutations,
    getters,
    actions
}